var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForeheadBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 357,
    viewBox: "0 0 545 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.431 274.08L137 355.941H273.661L274.431 274.08Z",
    fill: "#CDE9E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M532.519 326.539H466.65L486.503 135.227H512.82L532.519 326.539Z",
    fill: "#CDE9E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M422 356H373L387.769 215H407.346L422 356Z",
    fill: "#CDE9E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M410.477 274.08L272.893 355.941H409.708L410.477 274.08Z",
    fill: "#CDE9E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M544.102 273.955L407.211 355.942H544.102V273.955Z",
    fill: "#CDE9E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.431 275L0 356.861H136.661L137.431 275Z",
    fill: "#CDE9E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M455.415 110.746C473.859 110.746 488.811 98.162 488.811 82.6387C488.811 67.1154 473.859 54.5312 455.415 54.5312C436.971 54.5312 422.02 67.1154 422.02 82.6387C422.02 98.162 436.971 110.746 455.415 110.746Z",
    fill: "#CDE9E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M500.058 124.979C507.947 124.979 514.342 119.608 514.342 112.981C514.342 106.355 507.947 100.983 500.058 100.983C492.169 100.983 485.773 106.355 485.773 112.981C485.773 119.608 492.169 124.979 500.058 124.979Z",
    fill: "#CDE9E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M394.008 116.316C426.392 116.316 452.643 94.2214 452.643 66.9662C452.643 39.7109 426.392 17.6162 394.008 17.6162C361.625 17.6162 335.373 39.7109 335.373 66.9662C335.373 94.2214 361.625 116.316 394.008 116.316Z",
    fill: "#CDE9E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.828 100.513C344.806 100.513 371.54 78.0126 371.54 50.2567C371.54 22.5007 344.806 0 311.828 0C278.849 0 252.115 22.5007 252.115 50.2567C252.115 78.0126 278.849 100.513 311.828 100.513Z",
    fill: "#CDE9E4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.453 129.138C364.552 129.138 382.466 114.061 382.466 95.4613C382.466 76.8619 364.552 61.7842 342.453 61.7842C320.354 61.7842 302.439 76.8619 302.439 95.4613C302.439 114.061 320.354 129.138 342.453 129.138Z",
    fill: "#CDE9E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeheadBg2);
export default __webpack_public_path__ + "static/media/forehead-bg2.333e7505c6c3f95f0ae2496bfc504712.svg";
export { ForwardRef as ReactComponent };